import * as React from 'react';
import './LookupsLayout.scss';
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { SettingsSubMenu } from '../../../helpers/subMenuHelper';
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";

interface ILookupsLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    loading?: boolean;
    children?: any;
}

interface ILookupsLayoutActions {

}

type LookupsLayoutProps = ILookupsLayoutProps & ILookupsLayoutActions;

class LookupsLayout extends React.PureComponent<LookupsLayoutProps, any> {

    constructor(props: LookupsLayoutProps) {
        super(props);

    }

    render() {

        const {
            loading,
            permissions,
            permission
        } = this.props;

        let menu: any[] = [];

        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CategoriesView)) {
            menu.push({
                icon: undefined,
                title: "Categories",
                url: "/settings/general/categories"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.RolesView)) {
            menu.push({
                icon: undefined,
                title: "Roles",
                url: "/settings/general/roles"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CountriesView)) {
            menu.push({
                icon: undefined,
                title: "Countries",
                url: "/settings/general/countries"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.StatesView)) {
            menu.push({
                icon: undefined,
                title: "States",
                url: "/settings/general/states"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ItemComponentTypesView)) {
            menu.push({
                icon: undefined,
                title: "Item Component Types",
                url: "/settings/general/itemcomponenttypes"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.NoteTypesView)) {
            menu.push({
                icon: undefined,
                title: "Note Types",
                url: "/settings/general/notetypes"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InterestsView)) {
            menu.push({
                icon: undefined,
                title: "Interests",
                url: "/settings/general/interests"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MembershipTypesView)) {
            menu.push({
                icon: undefined,
                title: "Membership Types",
                url: "/settings/general/membershiptypes"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProfessionalDisciplinesView)) {
            menu.push({
                icon: undefined,
                title: "Professional Disciplines",
                url: "/settings/general/professionaldisciplines"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.SalutationsView)) {
            menu.push({
                icon: undefined,
                title: "Salutations",
                url: "/settings/general/salutations"
            });
        }

        return <RestrictedLayout
            subMenuItems={loading ? [] : SettingsSubMenu(permissions)}
            sub2MenuItems={loading ? [] : menu}
            loading={loading}
        >
            {permissions.length > 0 && permission && !AuthenticationHelper.hasPermission(permissions, permission) ?
                <div className="alert alert-warning d-flex">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                    </div>
                    <span>Permission Denied</span>
                </div>
                : this.props.children}
        </RestrictedLayout>;
    }

}


const mapStateToProps = (state: ITmdState, ownProps: LookupsLayoutProps): ILookupsLayoutProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
    return {
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children
    };
};

const mapDispatchToProps = (_dispatch): ILookupsLayoutActions => {
    return {
        
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(LookupsLayout);
